$(document).ready(function(){

  // ajout de classe si changement de langue

    // Récupérer la valeur de l'attribut lang
  var langAttributeValue = $('html').attr('lang');

  // Vérifier la valeur de l'attribut lang
  if (langAttributeValue === 'en') {
    // Ajouter une classe pour la version anglaise
    $('body').addClass('js version-anglaise');
  } else if (langAttributeValue === 'it') {
    // Ajouter une classe pour la version italienne
    $('body').addClass('js version-italienne');
  }

// Example


  // setTimeout(function() {
  //   $('.sls-purchase-options-container').css({
  //     'border-radius': '16px',
  //     'background-color': 'white',
  //     'overflow': 'hidden'
  //   });
  // }, 800);


  $('.shopify-challenge__button').addClass('cta-1 clr-brwn');


  setTimeout(function() {
    $('.sls-purchase-options-label').css({
      'display': 'none'
    });
  }, 800);

  setTimeout(function() {
    $('gty-whatsapp-chat-button').css({
      'z-index': '0'
    });
  }, 2000);


  setTimeout(function() {
    $('.cc-color-override-28801235.isense-cc-window').css({
        'z-index': '99991'
    });
  }, 800);

  
  setTimeout(function() {
    $('.related, .related + .media-arrow-container, .related-products__heading, .blog .blog__posts').show();

    // $('.related').css("opacity" , "1");


      /* slick related product */
      $('product-recommendations .related, .blog .blog__posts').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 2,
        arrows: true,
        dots: false,
        centerMode:false,
        infinite: false,
        centerPadding: "30px",
        prevArrow: ' <div class="media-prev-arrow slick-arrow" style=""><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
        nextArrow: '<div class="media-next-arrow slick-arrow" style=""><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
        responsive: [
          {
            breakpoint: 1300,
            settings: {
              infinite: true,
              slidesToShow: 2,
              slidesToScroll: 1,
              arrow: true,
              prevArrow:".arrow-prev",
              nextArrow:".arrow-next",
              centerMode: true,
              centerPadding: "0px"
            }
          },
          {
            breakpoint: 991,
            settings: {
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrow: true,
              prevArrow:".arrow-prev",
              nextArrow:".arrow-next",
              centerMode: true,
              centerPadding: "0px"
            }
          },
        ]
      });
}, 3000);

$('product-recommendations .related, .blog .blog__posts').on('afterChange', function(event, slick, currentSlide){
  var lastSlide = slick.slideCount - 1;
  if(currentSlide === lastSlide){
    $('.slick-next').addClass('slick-disabled');
  } else {
    $('.slick-next').removeClass('slick-disabled');
  }
});
  /* slick related product */


  /* fin slick related product */


  $('.team-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    prevArrow:".prev-team-btn",
    nextArrow:".next-team-btn",
    centerMode: true,
    centerPadding: "0px",
    arrow:true,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          arrow : false,
        }
      }]
  })

  /*chef partenaire*/
  
  $('.slider-wrapper').slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrow: true,
    prevArrow:".arrow-prev",
    nextArrow:".arrow-next",
    centerMode: true,
    centerPadding: "0px",
    responsive: [
  {
    breakpoint: 1500,
    settings: {
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrow: true,
      prevArrow:".arrow-prev",
      nextArrow:".arrow-next",
      centerMode: true,
      centerPadding: "0px"
    }
  },
      {
    breakpoint: 1024,
    settings: {
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrow: true,
      prevArrow:".arrow-prev",
      nextArrow:".arrow-next",
      centerMode: true,
      centerPadding: "0px"
    }
  },
      {
    breakpoint: 750,
    settings: {
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      centerMode: true,
      centerPadding: '150px',
      slidesToShow: 2,
      autoplay: true,
      autoplaySpeed: 4000,
    }
  },
      {breakpoint: 700,
      settings:{
        centerPadding: '100px',
      autoplay: true,
      autoplaySpeed: 2000,
        arrows: false,
        centerMode: true,
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 4000,
      }},
      {breakpoint: 600,
      settings:{
        centerPadding: '70px',
      autoplay: true,
      autoplaySpeed: 2000,
        arrows: false,
        centerMode: true,
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 4000,
      }},
      {breakpoint: 577,
      settings:{
        centerPadding: '90px',
      autoplay: true,
      autoplaySpeed: 2000,
        arrows: false,
        centerMode: true,
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 4000,
      }},
      {breakpoint: 500,
      settings:{
        centerPadding: '70px',
      autoplay: true,
      autoplaySpeed: 2000,
        arrows: false,
        centerMode: true,
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 4000,
      }},
      {breakpoint: 450,
      settings:{
        centerPadding: '50px',
      autoplay: true,
      autoplaySpeed: 2000,
        arrows: false,
        centerMode: true,
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 4000,
      }},
      {breakpoint: 376,
      settings:{
        centerPadding: '30px',
      autoplay: true,
      autoplaySpeed: 2000,
        arrows: false,
        centerMode: true,
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 4000,
      }}
    ]
  });

  
  /* slider collection produit homepage */


  $('.collection-produit-slick').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    // width: 500,
    dots: false,
    responsive : [
    {breakpoint : 1200,
      settings:{
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      // centerPadding: "0px",
      }
    },
    {breakpoint : 1024,
      settings:{
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      centerMode:true,
      prevArrow: ' <div class="media-prev-arrow slick-arrow" style=""><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
      nextArrow: '<div class="media-next-arrow slick-arrow" style=""><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
      centerPadding: "0px",
      }
    },
    {breakpoint : 749,
      settings:{
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      centerMode:false,
      infinite: false,
      centerPadding: "30px",
      prevArrow: ' <div class="media-prev-arrow slick-arrow" style=""><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
      nextArrow: '<div class="media-next-arrow slick-arrow" style=""><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
      }
    }
    ]
  });


  /* slider product media */

  $('.product__media-list').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    appendArrows: $('.media-arrow-container'),
    prevArrow: $('.media-prev-arrow'),
    nextArrow: $('.media-next-arrow')
  });

  /* slider product media >>  PACK TEMPLATE*/

  $('.product-slider-pack').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    appendArrows: $('.media-arrow-container'),
    prevArrow: $('.media-prev-arrow'),
    nextArrow: $('.media-next-arrow')
  });


  /* slider Pro type bloc (contact pro)*/

  

  $('.pro-bloc-1').slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    pauseOnFocus: false,
    appendArrows: $('.btn-wrapper-1'),
    prevArrow: $('.prev-team-btn-1'),
    nextArrow: $('.next-team-btn-1')
  });

  $('.pro-bloc-2').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    pauseOnFocus: false,
    autoplay: true,
    autoplaySpeed: 5500,
    appendArrows: $('.btn-wrapper-2'),
    prevArrow: $('.prev-team-btn-2'),
    nextArrow: $('.next-team-btn-2')
  });


  /* slider Pro type bloc (contact pro)*/




  /* tab menu product desc */

    $('ul.tabs li').click(function(){
      var tab_id = $(this).attr('data-tab');
  
      $('ul.tabs li').removeClass('current');
      $('.tab-content').removeClass('current');
  
      $(this).addClass('current');
      $("#"+tab_id).addClass('current');

      var spans = document.querySelectorAll('span[data-tab]');
      for (var i = 0; i < spans.length; i++) {
        let spani = spans[i];
        if (tab_id === spani.getAttribute('data-tab')) {
          
          // Ajoutez la classe "current" à l'élément <span> correspondant
          spani.classList.add('current');
        } else {
          // Supprimez la classe "current" des autres éléments <span>
          spani.classList.remove('current');
        }
      }
    });

     /* tab menu product mbl */
  

  $('.description-wrapper .container>span').click(function(){
    var tab_id = $(this).attr('data-tab');

    if ($(this).hasClass('current')) {
      $(this).toggleClass('current');
      $("#"+tab_id).toggleClass('current');
    }
    else{
      $('.description-wrapper span').removeClass('current');
      $('.tab-content').removeClass('current');
      
      $(this).toggleClass('current');
      $("#"+tab_id).toggleClass('current');
    }
  });



  // LIENS SCROLL UP

  var liensAncre = document.querySelectorAll('a[href^="#"]');

  liensAncre.forEach(function (lien) {
    lien.addEventListener("click", function (e) {
      e.preventDefault();
  
      var cibleId = lien.getAttribute("href").substring(1);
      var cible = document.getElementById(cibleId);
  
      if (cible.getAttribute("id") !== "desctiption-produit"){
        if (cible) {

          var position = cible.offsetTop - 150;
  
          window.scrollTo({
            top: position,
            behavior: "smooth"
          });
        }
      }
      else{
        if (window.innerWidth <= 479 ){
          var position = cible.offsetTop - 70;

          window.scrollTo({
            top: position,
            behavior: "smooth"
          });
        }
        else{
          var position = cible.offsetTop - 100;

          window.scrollTo({
            top: position,
            behavior: "smooth"
          });
        }
      }
     });
  });

// MENU MAIN LOGO NAVIGATION 




// Vérifiez si l'attribut "open" est présent

var burger = document.getElementById('Details-menu-drawer-container');
isTop = "false";


burger.addEventListener("click", function () {
  var header = document.querySelector(".shopify-section-header-sticky ");


  if (header === null){
    isTop = "true";

    var header = document.querySelector('.section-header')
  }

  var element = document.querySelector(".header__icon--menu");
  var montag = element.getAttribute("aria-expanded")  ;
  //console.log("mon tag : "+ montag);
  if (isTop == "true"){
    if (montag == "true") {

      header.classList.add("shopify-section-header-sticky");
    }
    else{
      header.classList.remove("shopify-section-header-sticky");    
      isTop = "false";
    }
  }
});
    

// Page Produit -> Alma (transform text en span)


function wrapWordsInSpans() {
  var textContainer = document.querySelector(".almatext");
  var text = textContainer.textContent;
  //console.log(text)
  var words = text.split(/\s+/); // Utilise une expression régulière pour diviser le texte par espaces

  for (let index = 0; index < words.length; index++) {
    //console.log(words[index])
    if (words[index] == "") {
      words.splice(index,1)
    }    
    if (words[index] == " ") {
      words.splice(index,1)
    }
  };
  // console.log(words)

  var newHTML = "";
  words.forEach(function(word, index) {
    // console.log(index)
    newHTML += "<span>" + word + "</span>";

    // Ajoute un espace entre les balises <span> pour préserver l'espacement
    if (index < words.length - 1) {
      newHTML += " ";
    }
  });

  textContainer.innerHTML = newHTML;
  
  $('.almatext').append($(".alma-img"))
};

          
  if (document.body.classList.contains("product-p")) {
  wrapWordsInSpans();
  };


  /* injection html */
$(".shopify-challenge__button").wrap("<div></div>");
$(".shopify-challenge__button").append('<span> <svg class="arrow-right" xmlns="http://www.w3.org/2000/svg" width="18.141" height="10.334" viewBox="0 0 18.141 10.334"> <g id="right-arrow_2_" data-name="right-arrow (2)" transform="translate(-5.302 -128.945)"> <g id="Groupe_100" data-name="Groupe 100" transform="translate(5.802 129.445)"> <path id="Tracé_33" data-name="Tracé 33" d="M16.981,131.738h0L13.1,127.517a.367.367,0,0,0-.548-.046.448.448,0,0,0-.042.6.406.406,0,0,0,.042.046l3.221,3.5H.388a.424.424,0,0,0,0,.844H15.769l-3.221,3.5a.448.448,0,0,0-.042.6.367.367,0,0,0,.548.046.4.4,0,0,0,.042-.046l3.885-4.221A.448.448,0,0,0,16.981,131.738Z" transform="translate(0 -127.369)" stroke="black" stroke-width="1"/> </g> </g> </svg> </span>');
$(".shopify-challenge__button").parent().attr("class","cta-1 clr-brwn");


/* avis clients */
  
setTimeout(popUP, 2000);

function popUP() {
  $(".fera-allReviews-heading-col1").prepend("<div class='avis-trust-wrapper'> <p class='avis-text'> Avis certifiés par </p> <img src='https://cdn.shopify.com/s/files/1/0755/1575/6853/files/Trustpilot_Logo__2022__svg.png?v=1686576971'> </div>");
  
  // VERSION ANGLAISE -> RETOUR PRODUITS 
  if (document.body.classList.contains("version-anglaise")) {
    if (document.querySelector(".avis-text") !== null) {
      var review = document.querySelector(".avis-text");
      review.innerText = "Certified trust from";
    };
  };

  // VERSION Italienne -> RETOUR PRODUITS 
  if (document.body.classList.contains("version-italienne")) {
    if (document.querySelector(".avis-text") !== null) {
      var review = document.querySelector(".avis-text");
      review.innerText = "pareri certificati da";
    };
  };
}


//var $date = $('.fera-allReviews-review:nth-child(1) .fera-allReviews-review-date');
//var $pp = $('.fera-allReviews-review:nth-child(1) .fera-allReviews-review-customer');
//$('.fera-allReviews-review:nth-child(1)').find($pp).insertAfter($date);

/*
      $(".reviews div").on("click", function(){
setTimeout(popUP, 2000);
  })
  $(".page-item a").on("click", function(){
setTimeout(popUP, 2000);
  })
*/

  /*detection input text focus unfocus */

    // Sélectionnez votre champ de texte par son ID
var $monInput = $("#NewsletterForm--sections--18838706880821__d41e9ec9-cf0a-4580-b18b-3119351d42bd");

// Ajoutez un gestionnaire d'événement pour l'événement keyup
$monInput.on("keyup", function() {
    // Vérifiez si le champ de texte est vide ou non
    if ($monInput.val().trim() !== "") {
        $('#NewsletterForm--sections--18838706880821__d41e9ec9-cf0a-4580-b18b-3119351d42bd + .field__label').hide();
    } else {
        $('#NewsletterForm--sections--18838706880821__d41e9ec9-cf0a-4580-b18b-3119351d42bd + .field__label').show();
    }
});
  
// jquery : active menu underline

$(".header__active-menu-item").parent().addClass("active-header")

// =========================================================
  
// PRENDRE L'URL
  function getCurrentURL () {
  return window.location.href
  };

  const url = getCurrentURL();

// SUPPRIME BOUTTON (RETOUR PRODUIT) SUR PAGE COLLECTION 
  console.log(url);
  if (url.includes("nos-produits-lucangeli")) {
      if (document.querySelector(".back-collection") !== null) {
        var collink = document.querySelector(".back-collection");
        collink.style.display = "none";
    };
  };


    // VERSION ANGLAISE -> Voir plus (product)
  if (document.body.classList.contains("version-anglaise")) {
    if (document.querySelector(".voir-plus-text") !== null) {
      var seemore = document.querySelector(".voir-plus-text");
      seemore.innerText = "See more";
    };
  };

  // VERSION Italienne -> Voir plus (product)
  if (document.body.classList.contains("version-italienne")) {
    if (document.querySelector(".voir-plus-text") !== null) {
      var seemore = document.querySelector(".voir-plus-text");
      seemore.innerText = "Mostra altri";
    };
  };

// // ==========================================================

//       // VERSION ANGLAISE -> POCHON
//   if (document.body.classList.contains("version-anglaise")) {
//     if (document.querySelector(".pochon-text") !== null) {
//       var pochon = document.querySelector(".pochon-text");
//       pochon.innerText = "Gift bag?";
//     };
//   };

//   // VERSION Italienne -> POCHON
//   if (document.body.classList.contains("version-italienne")) {
//     if (document.querySelector(".pochon-text") !== null) {
//       var pochon = document.querySelector(".pochon-text");
//       pochon.innerText = "sacchetto regalo ?";
//     };
//   };
  
// // ============================================================

// // VERSION ANGLAISE -> VOIR Plus (Produit) 
//   if (document.body.classList.contains("version-anglaise")) {
//     if (document.querySelector(".perso-picto") !== null) {
//       var perso = document.getElementsByClassName("perso-picto");
//       for(var i=0; i< perso.length; i++){
//       perso[i].innerText = "customizable";
//       };
//     };
//   };

// // VERSION ITALIENNE -> PERSONNALISABLER
//   if (document.body.classList.contains("version-italienne")) {
//     if (document.querySelector(".perso-picto") !== null) {
//       var perso = document.getElementsByClassName("perso-picto");
//       for(var i=0; i< perso.length; i++){
//       perso[i].innerText = "personalizzabile";
//       };
//     };
//   };
// ==================================================================

}); 


// iframe video

// Get element
var youtubeEmbedElement = document.getElementById("youtubeEmbed");

// Add YouTube API script
var tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var player;
var videoId = youtubeEmbedElement.dataset.videoId;
var startSeconds = 0;
// var endSeconds = 210;

onYouTubeIframeAPIReady = function () {
  player = new YT.Player("youtubeEmbed", {
    videoId: videoId, // YouTube Video ID
    playerVars: {
      autoplay: 1, // Auto-play the video on load
      autohide: 1, // Hide video controls when playing
      disablekb: 1,
      controls: 0, // Hide pause/play buttons in player
      showinfo: 0, // Hide the video title
      modestbranding: 1, // Hide the Youtube Logo
      loop: 1, // Run the video in a loop
      fs: 0, // Hide the full screen button
      rel: 0,
      enablejsapi: 1,
      modestbranding: 1,
      vq: 'hd1080',
      start: startSeconds
    },
    events: {
      onReady: function (e) {
        e.target.mute();
        e.target.playVideo();
      },
      onStateChange: function (e) {
        if (e.data === YT.PlayerState.PLAYING) {
          document.getElementById("youtubeEmbed").classList.add("loaded");
        }

        if (e.data === YT.PlayerState.ENDED) {
          // Loop from starting point
          player.seekTo(startSeconds);
        }
      }
    }
  });
};
